// extracted by mini-css-extract-plugin
export var checkbox = "_78-0";
export var circle = "_78-3";
export var horizontalContainer = "_78-7";
export var sm = "_78-5";
export var switch0 = "_78-2";
export var switchDisabled = "_78-8";
export var switchEnabled = "_78-1";
export var textSwitchContainer = "_78-9";
export var textSwitchOption = "_78-a";
export var textSwitchOptionSelected = "_78-b";
export var verticalContainer = "_78-6";
export var xs = "_78-4";